/*
 * vitruvio JS
 */

(function ($) {
	"use strict";

	$(document).ready(function () {
		// Comments

		$(".commentlist li").addClass("card mb-3");
		$(".comment-reply-link").addClass("btn btn-secondary");

		// Forms

		$(
			"select, input[type=text], input[type=email], input[type=password], textarea"
		).addClass("form-control");
		$("input[type=submit]").addClass("btn btn-primary");

		// Pagination fix for ellipsis

		$(".pagination .dots").addClass("page-link").parent().addClass("disabled");

		$(".hamburger--collapse").click(function () {
			$(this).toggleClass("is-active");
		});

		// $('.cta').on('mouseenter mousemove',function(e){
		// 	var parentOffset = $(this).offset();
		// 	// position dans l'élément
		// 	var relX = e.pageX - parentOffset.left;
		// 	var relY = e.pageY - parentOffset.top;
		// 	// dimensions de l'élément
		// 	var btnWidth = $(this).outerWidth();
		// 	var btnHeight = $(this).outerHeight();
		// 	// Position relative dans l'élément
		// 	var posX = relX * 100 / btnWidth;
		// 	var posY = relY * 100 / btnHeight;
		//
		// 	$(this).find('span').css('left', relX);
		// 	$(this).find('span').css('top', relY);
		// });

		$("#autore").hover(
			function () {
				
				$(this).addClass('drop-select');
				$(this).attr("size", $("#autore option").length);
			},
			function () {
	
				$(this).removeClass('drop-select');
				$(this).attr("size", 1);
			}
		);
		$("#categoria").hover(
			function () {
				
				$(this).addClass('drop-select');
				$(this).attr("size", $("#categoria option").length);
			},
			function () {
				
				$(this).removeClass('drop-select');
				$(this).attr("size", 1);
			}
		);
	});
})(jQuery);
